import { render, staticRenderFns } from "./PdfPreviewToolbarComponent.vue?vue&type=template&id=008b0618&lang=pug"
import script from "./PdfPreviewToolbarComponent.vue?vue&type=script&lang=ts"
export * from "./PdfPreviewToolbarComponent.vue?vue&type=script&lang=ts"
import style0 from "./PdfPreviewToolbarComponent.vue?vue&type=style&index=0&id=008b0618&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('008b0618')) {
      api.createRecord('008b0618', component.options)
    } else {
      api.reload('008b0618', component.options)
    }
    module.hot.accept("./PdfPreviewToolbarComponent.vue?vue&type=template&id=008b0618&lang=pug", function () {
      api.rerender('008b0618', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileManager/Preview/components/PdfPreviewComponent/PdfPreviewToolbarComponent.vue"
export default component.exports